<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <img
        class="w-100"
        src="../assets/imgs/arreglalo/banner-home-arreglalo2.jpg"
        alt="Arréglalo"
      />
    </section>


                  

    <section class="pt-5" id="seccionvideo">
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-12 pb-5">
            <iframe
              src="https://www.youtube.com/embed/BPqyFUbJ73A"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-12 pb-5 text-center">
            <div class="btnaction d-inline-block bold fG" @click="toggleOverlay()">
              ¡QUIERO GANAR DINERO YA!
            </div>
          </div>
          <div class="col-12 pb-5 text-center">
            <img
              src="../assets/imgs/arreglalo/flechaabajo-blanca.png"
              alt="¡QUIERO GANAR DINERO YA!"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>

    

    <section class="bgamarillo">
      <div class="container">
        <div class="row pt-5">
          <div class="col-12 pt-5">
            <p class="fXG azuloscuro bold">
              La industria del arreglo de ropa está creciendo exponencialmente
              debido a 3 factores de consumo en el mercado actual:
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="" id="exposicion">
      <div class="container pb-5">
        <div class="row">
          <div class="col-lg-12 pb-3 fG3 azuloscuro">
            <p>
              Los influencers y su interés por la moda; las compras de ropa por
              internet, donde al no poderse probar las prendas necesitan ajustes
              una vez que las personas las reciben; y finalmente, todos aquellos
              que se deciden por arreglar, ajustar y darle mayor uso a sus
              prendas para reducir su huella ambiental
            </p>
          </div>

          <div class="col-lg-12 pb-0">
            <div class="row">
              <div class="col-12">
                <div class="bgazul p-5 blanco">
                  <p class="fXG bold">
                    Por eso, una decisión inteligente es invertir en una
                    franquicia Arréglalo, ya que tendrás:
                  </p>
                  <ul class="fG beneficios">
                    <li class="pb-2">
                      Una sucursal con una rentabilidad predecible y escalable.
                    </li>
                    <li class="pb-2">
                      Un costo de producción extremadamente bajo, lo cuál
                      permite mayores ingresos para ti como dueño.
                    </li>
                    <li class="pb-2">
                      Procesos y metodología probadas que ayudarán al
                      crecimiento de tu negocio en la industria con mayor
                      crecimiento actualmente.
                    </li>
                    <li class="pb-2">
                      El apoyo experto del corporativo, miembro de la AMF quien
                      ha reconocido a <span class="fG3 bold">Arréglalo</span> como la mejor franquicia de
                      servicios en 3 ocasiones.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 pb-5 text-center">
            <img
              src="../assets/imgs/arreglalo/no-dejes-pasar-esta-oportunidad.png"
              alt="¡QUIERO GANAR DINERO YA!"
              class="img-fluid"
            />
          </div>
          <div class="col-12 pb-5 text-center">
            <div class="btnaction d-inline-block bold fG" @click="toggleOverlay()">
              ¡QUIERO GANAR DINERO YA!
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>

    <div class="overlay" v-if="$store.state.overlay == true">
      <div class="overlaybg" @click="toggleOverlay()"></div>
      <div class="overlay-contenido">
        <div class="container ">
          <div class="row">
            <div class="col-12 rounded shadow  py-4 contbtn bgazul">
              <div class="btncerrar" @click="toggleOverlay()">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
                  />
                </svg>
              </div>
              

              <div class="row ">

                <div class="col-12 text-center fG2 blanco bold pb-4">
                  Déjanos tus datos y en breve nos podremos en contacto.
                </div>

                <div class="col-10 offset-1 blanco">
                  

                    <form @submit="submitFormulario($event)">
                    
                      <label>
                        <span>Tu nombre:</span>
                        <input type="text" v-model="signupForm.nombre" placeholder="Tu nombre" required>
                      </label>
                      <label>
                        <span>Tu correo electrónico:</span>
                        <input type="email" v-model="signupForm.email" placeholder="Tu correo electrónico" required>
                      </label>
                      <label>
                        <span>Tu teléfono:</span>
                        <input type="tel" pattern="[0-9]{10}" title="Introduce un teléfono válido." v-model="signupForm.telefono" placeholder="Tu teléfono" required>
                      </label>

                     
                      <div class="py-4 text-center m-auto recaptcha">
                        <vue-recaptcha
                        ref="recaptcha"
                        sitekey="6LejQsYqAAAAANshgulDv3M6YKEShJc7LQzAV-wj"
                        @verify="onVerify"
                        @expired="onExpired"
                      ></vue-recaptcha> 
                      </div>

                      <label class="text-center">

                        <button type="submit" class="btnblanco d-inline-block">
                          ENVIAR
                        </button>

                      </label>
                    </form>

                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/FooterEmprende";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

import { VueRecaptcha } from 'vue-recaptcha';

export default {
  components: {
    Footer,
    SiteNav,
    VueRecaptcha
  },
  data() {
    return {
      recaptchaResponse: "",
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        email: "",
        telefono: "",
        
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      guia: false,
    };
  },
  name: 'Emprende',
  metaInfo: {
    title: 'Emprende | Arréglalo', // Sets the page title
    meta: [
      {
        name: 'description',
        content: '¡No dejes pasar esta oportunidad única de inversión!',
      },
    ],
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined) {
      this.traeDatos();
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    onVerify(response) {
      // Captures the reCAPTCHA response token
      this.recaptchaResponse = response;
      console.log("reCAPTCHA verified:", response);
    },
    onExpired() {
      // Handle reCAPTCHA expiration
      this.recaptchaResponse = "";
      console.log("reCAPTCHA expired.");
    },
    submitFormRecaptcha() {
      if (!this.recaptchaResponse) {
        alert("Please complete the reCAPTCHA.");
        return;
      }
      // Send the reCAPTCHA response to your backend for verification
      console.log("Submit form with reCAPTCHA:", this.recaptchaResponse);
    },
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    submitFormulario(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      let qData = this.signupForm;
      qData.recaptcha_response = this.recaptchaResponse;


      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
             
              this.toggleOverlay();

              this.signupForm = {
                nombre: "",
                email: "",
                telefono: ""
              };

              swal.fire("Datos registrados", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_zapatos = "";
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.handicap = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
        this.signupForm.talla_zapatos = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      }
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({click: this.$store.state.overlay})
    },
  },
};
</script>
